import { render, staticRenderFns } from "./CoachManager.vue?vue&type=template&id=aeb9648c"
import script from "./CoachManager.vue?vue&type=script&lang=js"
export * from "./CoachManager.vue?vue&type=script&lang=js"
import style0 from "./CoachManager.vue?vue&type=style&index=0&id=aeb9648c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports